
import styles from "./index.module.css";
import ProductPageSkeleton from "../store/template/default/product/product-page-skeleton";

const MarketplaceProductDetailsSkeleton = () => {
  return (
    <div className={styles.productsContainerNoBg}>
      <div className={styles.productDetails}>
        {" "}
        <ProductPageSkeleton />{" "}
      </div>
    </div>
  );
};

export default MarketplaceProductDetailsSkeleton;
